// Generated by purs version 0.15.15
import * as Control_Monad from "../Control.Monad/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var OnNextIsSymbol = {
    reflectSymbol: function () {
        return "OnNext";
    }
};
var OnErrorIsSymbol = {
    reflectSymbol: function () {
        return "OnError";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
    reflectSymbol: function () {
        return "OnComplete";
    }
});
var OnNext = /* #__PURE__ */ (function () {
    function OnNext(value0) {
        this.value0 = value0;
    };
    OnNext.create = function (value0) {
        return new OnNext(value0);
    };
    return OnNext;
})();
var OnError = /* #__PURE__ */ (function () {
    function OnError(value0) {
        this.value0 = value0;
    };
    OnError.create = function (value0) {
        return new OnError(value0);
    };
    return OnError;
})();
var OnComplete = /* #__PURE__ */ (function () {
    function OnComplete() {

    };
    OnComplete.value = new OnComplete();
    return OnComplete;
})();
var genericObservableEvent_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new OnNext(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new OnError(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return OnComplete.value;
        };
        throw new Error("Failed pattern match at Fusion.Data.ObservableEvent (line 14, column 1 - line 14, column 48): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof OnNext) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof OnError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof OnComplete) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Fusion.Data.ObservableEvent (line 14, column 1 - line 14, column 48): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericObservableEvent_);
var showObservableEvent = function (dictShow) {
    var genericShowSum = Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(OnNextIsSymbol));
    return function (dictShow1) {
        return {
            show: genericShow(genericShowSum(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow1))(OnErrorIsSymbol))(genericShowConstructor)))
        };
    };
};
var functorObservableEvent = {
    map: function (f) {
        return function (m) {
            if (m instanceof OnNext) {
                return new OnNext(f(m.value0));
            };
            if (m instanceof OnError) {
                return new OnError(m.value0);
            };
            if (m instanceof OnComplete) {
                return OnComplete.value;
            };
            throw new Error("Failed pattern match at Fusion.Data.ObservableEvent (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var eqObservableEvent = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (dictEq1) {
        var eq1 = Data_Eq.eq(dictEq1);
        return {
            eq: function (x) {
                return function (y) {
                    if (x instanceof OnNext && y instanceof OnNext) {
                        return eq1(x.value0)(y.value0);
                    };
                    if (x instanceof OnError && y instanceof OnError) {
                        return eq(x.value0)(y.value0);
                    };
                    if (x instanceof OnComplete && y instanceof OnComplete) {
                        return true;
                    };
                    return false;
                };
            }
        };
    };
};
var bifunctorObservableEvent = {
    bimap: function (left) {
        return function (right) {
            return function (v) {
                if (v instanceof OnError) {
                    return new OnError(left(v.value0));
                };
                if (v instanceof OnNext) {
                    return new OnNext(right(v.value0));
                };
                if (v instanceof OnComplete) {
                    return OnComplete.value;
                };
                throw new Error("Failed pattern match at Fusion.Data.ObservableEvent (line 17, column 22 - line 20, column 29): " + [ v.constructor.name ]);
            };
        };
    }
};
var monadObservableEvent = {
    Applicative0: function () {
        return applicativeObservableEven;
    },
    Bind1: function () {
        return bindObservableEvent;
    }
};
var bindObservableEvent = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof OnComplete) {
                return OnComplete.value;
            };
            if (v instanceof OnError) {
                return new OnError(v.value0);
            };
            if (v instanceof OnNext) {
                return v1(v.value0);
            };
            throw new Error("Failed pattern match at Fusion.Data.ObservableEvent (line 30, column 1 - line 33, column 26): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return $lazy_applyObservableEvent(0);
    }
};
var applicativeObservableEven = /* #__PURE__ */ (function () {
    return {
        pure: OnNext.create,
        Apply0: function () {
            return $lazy_applyObservableEvent(0);
        }
    };
})();
var $lazy_applyObservableEvent = /* #__PURE__ */ $runtime_lazy("applyObservableEvent", "Fusion.Data.ObservableEvent", function () {
    return {
        apply: Control_Monad.ap(monadObservableEvent),
        Functor0: function () {
            return functorObservableEvent;
        }
    };
});
var applyObservableEvent = /* #__PURE__ */ $lazy_applyObservableEvent(24);
export {
    OnNext,
    OnError,
    OnComplete,
    genericObservableEvent_,
    bifunctorObservableEvent,
    functorObservableEvent,
    applyObservableEvent,
    applicativeObservableEven,
    bindObservableEvent,
    monadObservableEvent,
    showObservableEvent,
    eqObservableEvent
};
//# sourceMappingURL=index.js.map
